"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationLink = exports.Location = void 0;
var Location_1 = require("./Location");
Object.defineProperty(exports, "Location", { enumerable: true, get: function () { return __importDefault(Location_1).default; } });
var LocationLink_1 = require("./LocationLink");
Object.defineProperty(exports, "LocationLink", { enumerable: true, get: function () { return LocationLink_1.LocationLink; } });
//# sourceMappingURL=index.js.map